import { RocketRequestTimeoutError } from '@/errors/RocketRequestTimeoutError';
import { sendRequestToRocketAndWaitForResponse } from './messaging';

export {
  stopWaitingForReadyNotificationFromRocket,
  waitForReadyNofificationFromRocket,
} from './readyNotification';

// Pretty generous with these for now
const ROCKET_SAVE_CONTACT_FORM_REQUEST_TIMEOUT_MS = 10 * 1000;
const ROCKET_GO_TO_CONTACT_REQUEST_TIMEOUT_MS = 30 * 1000;
const ROCKET_IS_CONTACT_FORM_DIRTY_REQUEST_TIMEOUT_MS = 10 * 1000;

// The default in rocket by itself is 10000
const ROCKET_SAVE_ALERT_TIMEOUT_MS = 2.5 * 1000;

const getRocketIFrame = () => {
  const iFrame = window?.document?.getElementById('volman-rocket-iframe') as HTMLIFrameElement;
  if (!iFrame) {
    console.warn('Unable to get rocket iframe');
  }
  return iFrame;
};

export async function openContactInRocket(contactId: number) {
  try {
    // LIST-905: console.log(`openContactInRocket: ${contactId}`);
    await sendRequestToRocketAndWaitForResponse(
      getRocketIFrame(),
      {
        name: 'goToContact',
        contactId,
      },
      ROCKET_GO_TO_CONTACT_REQUEST_TIMEOUT_MS
    );
    // LIST-905: console.log(`End openContactInRocket: ${contactId}`);
  } catch (err) {
    if (err instanceof RocketRequestTimeoutError) {
      console.error(err.message, err.request);
      return false;
    } else {
      throw err;
    }
  }
}

export async function saveContactFormInRocket() {
  try {
    const response = await sendRequestToRocketAndWaitForResponse(
      getRocketIFrame(),
      {
        name: 'saveContactForm',
        alertTimeoutMs: ROCKET_SAVE_ALERT_TIMEOUT_MS,
      },
      ROCKET_SAVE_CONTACT_FORM_REQUEST_TIMEOUT_MS
    );
    return response.success ?? false;
  } catch (err) {
    if (err instanceof RocketRequestTimeoutError) {
      console.error(err.message, err.request);
      return false;
    } else {
      throw err;
    }
  }
}

export async function isContactFormDirtyInRocket() {
  try {
    const response = await sendRequestToRocketAndWaitForResponse(
      getRocketIFrame(),
      {
        name: 'isContactFormDirty',
      },
      ROCKET_IS_CONTACT_FORM_DIRTY_REQUEST_TIMEOUT_MS
    );

    if (!response.contactFormAvailable) {
      console.error('isContactFormDirtyInRocket(): contact form not available');
    }

    return (response.contactFormDirty && !response.contactFormSaving) ?? false;
  } catch (err) {
    if (err instanceof RocketRequestTimeoutError) {
      console.error(err.message, err.request);
      return false;
    } else {
      throw err;
    }
  }
}
